import { render, staticRenderFns } from "./choice_echo.vue?vue&type=template&id=25368489&scoped=true"
import script from "./choice_echo.vue?vue&type=script&lang=js"
export * from "./choice_echo.vue?vue&type=script&lang=js"
import style0 from "./choice_echo.vue?vue&type=style&index=0&id=25368489&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25368489",
  null
  
)

export default component.exports